export default __webpack_public_path__ + "static/media/5.b0bc42a3.jpg";